function _check_private_redeclaration(obj, privateCollection) {
    if (privateCollection.has(obj)) {
        throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
}
function _class_apply_descriptor_get(receiver, descriptor) {
    if (descriptor.get) {
        return descriptor.get.call(receiver);
    }
    return descriptor.value;
}
function _class_apply_descriptor_set(receiver, descriptor, value) {
    if (descriptor.set) {
        descriptor.set.call(receiver, value);
    } else {
        if (!descriptor.writable) {
            throw new TypeError("attempted to set read only private field");
        }
        descriptor.value = value;
    }
}
function _class_extract_field_descriptor(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to " + action + " private field on non-instance");
    }
    return privateMap.get(receiver);
}
function _class_private_field_get(receiver, privateMap) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "get");
    return _class_apply_descriptor_get(receiver, descriptor);
}
function _class_private_field_init(obj, privateMap, value) {
    _check_private_redeclaration(obj, privateMap);
    privateMap.set(obj, value);
}
function _class_private_field_set(receiver, privateMap, value) {
    var descriptor = _class_extract_field_descriptor(receiver, privateMap, "set");
    _class_apply_descriptor_set(receiver, descriptor, value);
    return value;
}
var _controllers = new WeakMap();
export class FetcherAbortManager {
    get(requestId) {
        return _class_private_field_get(this, _controllers).get(requestId);
    }
    set(requestId) {
        const controller = new AbortController();
        _class_private_field_get(this, _controllers).set(requestId, controller);
        return controller;
    }
    setSafe(requestId) {
        if (!requestId) return null;
        return this.set(requestId).signal;
    }
    has(requestId) {
        return _class_private_field_get(this, _controllers).has(requestId);
    }
    clear(requestId) {
        return _class_private_field_get(this, _controllers).delete(requestId !== null && requestId !== void 0 ? requestId : '');
    }
    abort(requestId) {
        const id = requestId !== null && requestId !== void 0 ? requestId : '';
        if (!id || !this.has(id)) return false;
        const controller = this.get(id);
        controller.abort();
        return this.clear(id);
    }
    constructor(){
        _class_private_field_init(this, _controllers, {
            writable: true,
            value: void 0
        });
        _class_private_field_set(this, _controllers, new Map());
    }
} /*#__PURE__*/ 

//# sourceMappingURL=data:application/json;base64,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